export { default } from './loading-view.js';